export default __webpack_public_path__ + "static/media/404.59d1f9fd.svg";